import Vue from 'vue'
import Vuex from 'vuex'
import TestModule from '@/store/modules/test.module'
import axiosInstance from '../api/axiosInstance'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    Gallery: null,
    userInfo: null,
    iframeData: {},
    product: '',
    initMsg: null,
    theme: 'dark',
    permissionLoad: false,
    accessBillingInternal: false,
    modifyBillingInternal: false
  },
  mutations: {
    saveTheme (state, value) {
      if (['light', 'dark'].includes(value)) {
        state.theme = value
      }
    },
    saveGallery (state, value) {
      state.Gallery = value
    },
    saveUserInfo (state, value) {
      state.userInfo = value
    },
    saveInitMsg (state, value) {
      state.initMsg = value
    },
    saveIframeData (state, value) {
      state.iframeData = value
    },
    handleIframeData (state, value) {
      if (value) {
        state.product = value.product
        state.iframeData = value.result
        console.log(state.iframeData)
      } else {
        state.product = ''
        state.iframeData = {}
      }
    },
    saveAccessBillingInternal (state, value) {
      state.accessBillingInternal = value
    },
    saveModifyBillingInternal (state, value) {
      state.modifyBillingInternal = value
    },
    updateLoadPermission (state) {
      state.permissionLoad = true
    }
  },
  actions: {
    billingInternalPermission ({ commit, state }, value) {
      return axiosInstance.get('/route-billing/billing-service/user/billingInternalPermission').then(res => {
        const result = res.data.result
        // result.accessBillingInternal = false
        const flag = state.userInfo.role === 3 || result.accessBillingInternal
        commit('saveAccessBillingInternal', flag)
        commit('saveModifyBillingInternal', result.modifyBillingInternal)
        commit('updateLoadPermission')

        return flag
      }).catch((error) => {
        console.log(error)
        commit('updateLoadPermission')
      })
    }
  },
  modules: {
    TestModule
  }
})
